/**
 * @todo fix circular dependency
 */
/* eslint-disable @nx/enforce-module-boundaries */
import { type ComponentProps } from 'react'
import { type LogoProps as JadeLogoProps, Logo as JadeLogo } from '@stone-payments/jade'

type LogoColor = 'brand' | 'white' | 'dark'

interface LogoProps extends ComponentProps<'div'> {
  height: number
  color?: LogoColor
}

const jadeLogoColorMap: Record<LogoColor, Exclude<JadeLogoProps['color'], 'ton-green'> | 'dark'> = {
  brand: 'dark-green',
  white: 'white',
  dark: 'dark'
}

function LogoWrapper({ children, ...rest }: ComponentProps<'div'>) {
  return (
    <div role="img" {...rest}>
      {children}
    </div>
  )
}

export const StoneLogo = ({ color = 'brand', height, ...rest }: LogoProps) => {
  if (height < 24) {
    throw new Error(`StoneLogo height must be at least 24px, but received ${height}px`)
  }

  const colorJadeLogo = color === 'dark' ? 'dark-green' : (jadeLogoColorMap[color] as 'white' | 'dark-green')
  return (
    <LogoWrapper {...rest}>
      <JadeLogo use="stone" height={height} color={colorJadeLogo} />
    </LogoWrapper>
  )
}
